var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},_vm._l((_vm.$route.path == '/document' &&
    _vm.$route.query.title == '公众服务'
      ? _vm.tabItem.grouping2.filter((item) => item.tag !== '承检能力')
      : _vm.tabItem.children),function(item,i){return _c('div',{key:i,staticClass:"tab-item",class:{
      'is-active': item.tag == _vm.activeName,
      long: item.tag == '诚信检验检测承诺书',
    },style:(`left:${item.left ? item.left : i * _vm.mypx}px;z-index:${
      _vm.tabItem.children.length + 1 - i
    };`),on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item.tag)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }